export const init = () => {
    if (document.querySelector('.s-detail-page--type3')) {
        const mediaQuery = window.matchMedia('(max-width: 1055px)');
        const mainContent = document.querySelector(".main-content-wrapper");
        const asideContent = document.querySelector(".aside-content-wrapper");
        const carousel = document.getElementById("js-cp-main-carousel");
        function handleWindowSizeChange(event) {
            if (event.matches) {
                // Moving
                if (document.getElementById("js-cp-main-carousel")) {
                    const carouselhHeading = carousel.previousElementSibling;
                    mainContent.insertAdjacentElement('beforebegin', carouselhHeading);
                    carouselhHeading.style.cssText = 'font-family: FK Grotesk; font-size: 24px;font-weight: 830;line-height: 27px;color: #4c4c4c;margin-top: 24px;margin-bottom: 8px;';
                    mainContent.insertAdjacentElement('beforebegin', carousel);
                    carousel.style.marginBottom = "32px";
                }
                mainContent.insertAdjacentElement('afterend', asideContent);
                asideContent.style.backgroundColor = "#F5F6FF";
            } else {
                if (document.getElementById("js-cp-main-carousel")) {
                    const carouselhHeading = carousel.previousElementSibling;
                    asideContent.insertAdjacentElement('afterbegin', carousel);
                    asideContent.insertAdjacentElement('afterbegin', carouselhHeading);
                    carouselhHeading.style = "";
                    carousel.style = "";
                }
                document.querySelector(".js-aside-row").insertAdjacentElement('afterbegin', asideContent);
                asideContent.style = "";
            }
        }

        handleWindowSizeChange(mediaQuery);

        mediaQuery.addListener(handleWindowSizeChange);
    }
};